import React from "react";
// import './Disclaimer.css'
import disclaimerBanner from '../assets/bannerImages/disclaimerBanner.webp'
// import monitoringTheDeviation from '../assets/images/monitoringTheDeviation.webp'
import { Link } from "react-router-dom";

export default function Disclaimer(){
    return(
        <div className="disclaimer">
            <DR1/>
            <DR2/>
            <DR3/>
            <ContactSection/>
        </div>
    )
}

function DR1(){
    return(
        <div className="dr1">
            <h1 className="title">Disclaimer</h1>
                <div className="overlay"/>
            <img loading="lazy" src={disclaimerBanner} alt="r1-img" className="r1-img"/>
        </div>
    )
}

function DR2(){
    return(
        <div className="dr2">
            <h1>Disclaimer</h1>
        </div>
    )
}

function DR3(){
    return(
        <div className="dr3">
            <div className="content">
                <div className="rowOne row">
                    <h4 className="heading">1. Use of Website</h4>
                    <p className="para">By using this website, you agree to comply with and be bound by the following terms and conditions of use. If you do not agree to these terms and conditions, please do not use this website.</p>
                </div><br/><br/>

                <div className="rowTwo row">
                    <h4 className="heading">2. Information Accuracy</h4>
                    <p className="para">The information provided on this website is for general informational purposes only. We make no representations or warranties of any kind, express or implied, about the accuracy, completeness, reliability, suitability, or availability of the information, products, services, or related graphics contained on the website for any purpose. Any reliance you place on such information is therefore strictly at your own risk.</p>
                </div><br/><br/>

                <div className="rowThree row">
                    <h4 className="heading">3. Professional Advice</h4>
                    <p className="para">The content of this website does not constitute professional advice. You should consult with qualified professionals or specialists before making any decisions based on the information provided on this website.</p>
                </div><br/><br/>

                <div className="rowFour row">
                    <h4 className="heading">4. External Links</h4>
                    <p className="para">This website may contain links to external websites that are not under our control. We have no control over the nature, content, and availability of those sites. The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them.</p>
                </div><br/><br/>

                <div className="rowFive row">
                    <h4 className="heading">5. Limitation of Liability</h4>
                    <p className="para">In no event will Bixian performance Marketing Ltd be liable for any loss or damage, including but not limited to indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arising out of or in connection with the use of this website.</p>
                </div><br/><br/>

                <div className="rowSix row">
                    <h4 className="heading">6. Changes to Terms</h4>
                    <p className="para">We may revise these terms and conditions at any time without notice. By using this website, you agree to be bound by the current version of these terms and conditions.</p>
                </div><br/><br/>

                <div className="rowSeven row">
                    <h4 className="heading">7. Privacy</h4>
                    <p className="para">Please refer to our Privacy Policy to understand how we collect, use, and protect your personal information when you use this website.</p>
                </div><br/><br/>

                <div className="rowEight row">
                    <h4 className="heading">8. Governing Law</h4>
                    <p className="para">This disclaimer shall be governed by and construed in accordance with the laws of Indian Jurisdiction, any disputes relating to this disclaimer will be subject to the exclusive jurisdiction of the courts in Indian Jurisdiction.</p>
                </div><br/><br/>

                <div className="rowFive row">
                    <h4 className="heading">Contact Us</h4>
                    <p className="para">If you have any questions, concerns, or requests regarding our Privacy Policy or the handling of your personal information, please contact us.</p>
                    <p className="para">By using our website, you consent to the practices described in this Privacy Policy.</p>
                </div><br/><br/>

            </div>
        </div>
    )
}

function ContactSection(){
    return(
        <div className="contactSection">
                <div className="box">
                    <div className="context">
                        <h1>Wanna Discuss With Us?</h1>
                        <p>Schedule a free consultation and esitmate with our expert.</p>
                    </div>
                    <div className="buttonHolder">
                        <Link to='/contact'><button>Get A Free Estimation</button></Link>
                    </div>
                </div>
            </div>
    )
}